import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeaturedRefreshCw3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_632_1398)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M2.5 7C2.5 3.96243 4.96243 1.5 8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7Z",
			stroke: "#D6D6D6",
			shapeRendering: "crispEdges"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M19.3333 23.6667C19.3333 23.6667 19.8995 23.5858 22.2426 21.2426C24.5858 18.8995 24.5858 15.1005 22.2426 12.7574C21.4125 11.9272 20.3995 11.3911 19.3333 11.1492M19.3333 23.6667H23.3333M19.3333 23.6667L19.3333 19.6667M16.6667 10.3335C16.6667 10.3335 16.1005 10.4143 13.7574 12.7575C11.4142 15.1006 11.4142 18.8996 13.7574 21.2428C14.5875 22.073 15.6005 22.609 16.6667 22.8509M16.6667 10.3335L12.6667 10.3333M16.6667 10.3335L16.6667 14.3333",
			stroke: "#424242",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_632_1398",
		x: 0,
		y: 0,
		width: 36,
		height: 36,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_632_1398"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_632_1398",
				result: "shape"
			})
		]
	}) })]
});
export default SvgFeaturedRefreshCw3;
